import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";

function About({ onNext }) {
  return (
    <SoftBox>
      <SoftBox width="80%" textAlign="center" mx="auto" mb={4}>
        <SoftTypography variant="h4" fontWeight="bold">
          UDS PBX Cloud (3CX)
        </SoftTypography>
        <SoftTypography variant="body1" fontWeight="regular" color="text">
          Moderne Cloud-Telefonanlage basierend auf 3CX mit umfangreichen
          Unified Communications Features. Ideal für Unternehmen jeder Größe,
          die eine professionelle Kommunikationslösung suchen.
        </SoftTypography>
      </SoftBox>

      <SoftBox mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <SoftTypography variant="h6" fontWeight="medium">
              Telefonie-Features
            </SoftTypography>
            <SoftTypography variant="body2" color="text">
              - Voice over IP (VoIP) <br />
              - Anrufweiterleitung <br />
              - Voicemail-to-Email <br />
              - IVR/Digitale Rezeption <br />
              - Warteschlangen-Management
            </SoftTypography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <SoftTypography variant="h6" fontWeight="medium">
              Unified Communications
            </SoftTypography>
            <SoftTypography variant="body2" color="text">
              - Videokonferenzen <br />
              - Instant Messaging <br />
              - Presence Management <br />
              - Screen Sharing <br />
              - Mobile Apps
            </SoftTypography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <SoftTypography variant="h6" fontWeight="medium">
              Integration & Reports
            </SoftTypography>
            <SoftTypography variant="body2" color="text">
              - CRM-Integration <br />
              - Microsoft Teams Integration <br />
              - Detaillierte Statistiken <br />
              - Call Recording <br />
              - API-Zugriff
            </SoftTypography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <SoftTypography variant="h6" fontWeight="medium">
              Sicherheit & Support
            </SoftTypography>
            <SoftTypography variant="body2" color="text">
              - Verschlüsselte Kommunikation <br />
              - Backup & Failover <br />
              - 24/7 Monitoring <br />
              - SIP-Firewall <br />
              - Technischer Support
            </SoftTypography>
          </Grid>
        </Grid>
      </SoftBox>

      <SoftBox mt={4} textAlign="center">
        <SoftButton color="info" onClick={onNext}>
          PBX jetzt konfigurieren
        </SoftButton>
      </SoftBox>
    </SoftBox>
  );
}

About.propTypes = {
  onNext: PropTypes.func.isRequired,
};

export default About;